import { observable, toJS, flow, action } from "mobx";
import { getContentGroup, deleteArticles, saveContentGroup, downloadKMCampaigns, downloadKMArticles, generateArticles, stopGeneratingArticles } from "services/contentgroups";
import { registerHandler, delay } from "services/api";
import { message } from "antd";
import _ from "lodash";

export default class ContentGroupStore {
	constructor() {
		this.ui = this.getUI();
		this.ui.loadingContentGroup = true;
	}

	@observable
	contentGroup = {};

	@observable
	articles = [];

	@observable
	kmCampaigns = [];

	@observable
	generatorJob = null;

	getUI = () => {
		let ui = {
			loadingContentGroup: false,
			savingSettings: false,
			deletingArticles: false,
			savingSettings: false,
			importArticlesDialogVisible: false,
			importingArticles: false,			
			importArticlesByTitleDialogVisible: false,
			importingArticlesByTitle: false,
			downloadKMArticlesDialogVisible: false,
			downloadingKMArticles: false,
			updatingKMCampaigns: false,
			openAIDrawerVisible: false,
			startGeneratingOpenAIArticles: false,
		};
		return observable.object(ui);
	};

	createFormObject = object => {
		function customizer(value, key) {
			if (!_.isObject(value) && key !== "value") {
				return {
					value: value
				};
			}
			if (_.isArray(value)) {
				return _.cloneDeep(value);
			}
		}

		let newObj = _.cloneDeepWith(toJS(object), customizer);
		return newObj;
	};

	getRawObjectFromFormObject = formObject => {
		function customizer(value) {
			if (_.isObject(value)) {
				if ("value" in value) {
					return value.value;
				}
			}
		}
		let rawJS = toJS(formObject);
		return _.cloneDeepWith(rawJS, customizer);
	};

	@action
	formChanged = fields => {
		let customizer = (objValue, srcValue, key, object, source, stack) => {
			if (srcValue == undefined) {
				return null;
			}
		};
		_.mergeWith(this.stateForm, fields, customizer);
	};

	remoteDeleteArticles = flow(function*(ids) {
		this.ui.deletingArticles = true;
		const response = yield deleteArticles(this.contentGroup.id, ids);
		this.ui.deletingArticles = false;
		if (response == null) {
			message.error("Failed to delete selected articles. Unknown error", 3);
			return;
		}
		if (response.error) {
			message.error(response.error.message, 3);
			return;
		}

		message.success("Successfully deleted selected articles", 3);
	});

	@action
	deleteArticles = ids => {
		_.remove(this.articles, article => {
			return ids.includes(article.id);
		});
	};

	@action
	addArticle = article => {
		article.usageCount = 0;
		this.articles.push(article);
	};

	@action
	updateGeneratorProgress = job => {
		this.generatorJob = observable.object(job);;
	};

	@action
	addArticles = articles => {
		for (let i = 0; i < articles.length; i++) {
			let article = articles[i];
			article.usageCount = 0;
			this.articles.push(article);
		}
	}

	@action
	updateArticle = article => {
		const foundIndex = this.articles.findIndex(el => {
			return el.id == article.id;
		});

		if (foundIndex != -1) {
			this.articles[foundIndex].title = article.title;
		}
	};

	@action
	showImportArticlesDialog = () => {
		this.ui.importArticlesDialogVisible = true;
	}

	@action
	showDownloadKMArticlesDialog = () => {
		this.ui.downloadKMArticlesDialogVisible = true;
	}

	@action
	hideDownloadKMArticlesDialog = () => {
		this.ui.downloadKMArticlesDialogVisible = false;
	}

	@action
	hideImportArticlesDialog = () => {
		this.ui.importArticlesDialogVisible = false;
	}

	@action
	showImportArticlesByTitleDialog = () => {
		this.ui.importArticlesByTitleDialogVisible = true;
	}

	@action
	hideImportArticlesByTitleDialog = () => {
		this.ui.importArticlesByTitleDialogVisible = false;
	}

	@action
	showOpenAIDrawer = () => {
		this.ui.openAIDrawerVisible = true;
	};

	@action
	hideOpenAIDrawer = () => {
		this.ui.openAIDrawerVisible = false;
	};


	generateArticles = flow(function*(payload) {
		this.ui.startGeneratingOpenAIArticles = true;
		const response = yield generateArticles(payload);
		console.log("Response is: ", response);
		this.ui.startGeneratingOpenAIArticles = false;
		if (response == null) {
			message.error(
				"Failed to generate OpenAI articles. Unknown error",
				5
			);
			return;
		}

		if (response.error) {
			message.error(response.error.message, 5);
			return;
		}

		message.success("Successfully start generating OpenAI articles", 5);
		this.hideOpenAIDrawer();
		return;
	});
	

	updateKMCampaigns = flow(function*() {
		//http://localhost:8080/action/download/kmcampaigns
		this.ui.updatingKMCampaigns = true;
		const response = yield downloadKMCampaigns();
		this.ui.updatingKMCampaigns = false;
		if (response == null) {
			message.error("Failed to Kontent Machine campaigns", 5);
			return;
		}

		if (response.error) {
			message.error(response.error.message, 5);
			return;
		}
		
		this.kmCampaigns = observable.array(response.campaigns);
	})

	downloadKMArticles = flow(function*(kmCampaignId) {
		this.ui.downloadingKMArticles = true;
		const response = yield downloadKMArticles(this.contentGroup.id, {
			articleSource: "KontentMachine",
			inputInfo: kmCampaignId
		});
		this.ui.downloadingKMArticles = false;
		if (response == null) {
			message.error("Failed to download Kontent Machine articles", 5);
			return;
		}

		if (response.error) {
			message.error(response.error.message, 5);
			return;
		}

		this.ui.downloadKMArticlesDialogVisible = false;
		message.success("Sucessfully downloaded Kontent Machine articles", 5);
	})

	saveSettings = flow(function*() {
		let contentGroup = this.getRawObjectFromFormObject(this.stateForm);		
		this.ui.savingSettings = true;
		yield delay(500);
		const response = yield saveContentGroup(contentGroup);
		this.ui.savingSettings = false;
		if (response == null) {
			message.error("Failed to save settings. Unknown error");
			return;
		}

		if (response.error) {
			message.error(response.error.message);
			return;
		}

		message.success("Successfully saved settings");
	});

	stopGeneratingArticles = flow(function*() {
		console.log(this.contentGroup.id);
		const response = yield stopGeneratingArticles(this.contentGroup.id);
		if (response != null) {
			if (response.error) {
				message.error(response.error.message);
				return;
			}
		} else {
			message.error("Failed to stop generating article. Unknown error.");
			return;
		}
	});

	loadContentGroup = flow(function*(contentGroupId) {
		this.ui = this.getUI();
		this.ui.loadingContentGroup = true;
		const response = yield getContentGroup(contentGroupId);
		this.ui.loadingContentGroup = false;
		if (response == null) {
			message.error("Failed to load content articles. Unexpected error", 3);
			return;
		}
		if (response.error) {
			message.error(response.error.message, 3);
			return;
		}
		this.contentGroup = observable.object(response.contentGroup);
		if (response.generatorJob) {
			this.generatorJob = observable.object(response.generatorJob);
		}
		this.articles = observable.array(response.articles);
		this.kmCampaigns = observable.array(response.kmCampaigns);
		this.stateForm = this.createFormObject(response.contentGroup);		

		registerHandler([
			{
				path: "content_group/" + contentGroupId,
				handler: (err, msg) => {
					if (err != null) return;
					const obj = JSON.parse(msg.body);
					console.log("Message body is", msg.body);
					if (obj.action == "generatorProgress") {
						this.updateGeneratorProgress(obj.generatorJob);
						return;
					}

					if (obj.action == "newArticle") {
						var article = obj.article;
						this.addArticle(article);
						return;
					}

					if (obj.action == "newArticles") {
						let articles = obj.articles;
						this.addArticles(articles);
						return;
					}

					if (obj.action == "editArticle") {
						// console.log("Edited article");
						// console.log(obj.article);
						var article = obj.article;
						this.updateArticle(article);
						return;
					}

					if (obj.action == "articlesDeleted") {
						this.deleteArticles(obj.articles);
						return;
					}
				}
			}
		]);
	});
}
